if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (!this.form) {
          console.error('ProductForm: No form found');
          return;
        }

        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (!this.submitButton) {
          console.error('ProductForm: No submit button found');
          return;
        }

        this.submitButtonText =
          this.submitButton.querySelector('span') || this.submitButton.querySelector('h5') || this.submitButton;

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        console.log('ProductForm initialized successfully');
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        console.log('Product form submit handler triggered');

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');

        const spinner = this.querySelector('.loading__spinner');
        if (spinner) {
          spinner.classList.remove('hidden');
        }

        // Also handle sticky button if it exists
        const stickyButton = document.querySelector('.product-bottom-sticky__add-to-cart');
        let stickyButtonText = null;
        let stickyOriginalText = '';
        if (stickyButton) {
          stickyButton.classList.add('loading');
          const stickySpinner = stickyButton.querySelector('.loading__spinner');
          if (stickySpinner) {
            stickySpinner.classList.remove('hidden');
          }
          // Store original text for sticky button
          stickyButtonText = stickyButton.querySelector('h5');
          if (stickyButtonText) {
            stickyOriginalText = stickyButtonText.textContent;
            stickyButtonText.textContent = 'Adding to cart...';
          }
        }

        // Show simple loading immediately - drawer will open with loading already active
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          cartDrawer.showSimpleLoading();
        }

        // Only change text for non-quick-add buttons (buttons with text content)
        const isQuickAddButton = this.submitButton.classList.contains('quick-add__submit');
        let originalText = '';

        if (!isQuickAddButton && this.submitButtonText) {
          originalText = this.submitButtonText.textContent;
          this.submitButtonText.textContent = 'Adding to cart...';
          this.submitButton.dataset.originalText = originalText;
        }

        // Dispatch cart updating event
        document.dispatchEvent(new CustomEvent('cart:updating'));

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;

            // Dispatch cart updated event
            document.dispatchEvent(
              new CustomEvent('cart:updated', {
                detail: {
                  source: 'product-form',
                  cartData: response,
                  productVariantId: formData.get('id'),
                },
              })
            );

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  // Use direct cart update since CartUpdateManager is disabled
                  const cartDrawerItems = document.querySelector('cart-drawer-items');
                  if (cartDrawerItems) {
                    setTimeout(() => {
                      const cartDrawer = document.querySelector('cart-drawer');
                      if (cartDrawer) {
                        cartDrawer.open();
                      }
                    }, 100);
                  }
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              // Enhanced cart update with empty cart detection
              const cartDrawerItems = document.querySelector('cart-drawer-items');
              const cartDrawer = document.querySelector('cart-drawer');

              if (cartDrawerItems && cartDrawer) {
                // Check if cart was empty before adding item
                const wasCartEmpty = cartDrawer.classList.contains('is-empty');

                console.log(`Product added to ${wasCartEmpty ? 'empty' : 'non-empty'} cart`);

                if (wasCartEmpty) {
                  // For empty cart, use DOM refresh approach
                  console.log('Triggering DOM refresh for empty cart scenario');

                  // Open drawer first with loading
                  cartDrawer.open();

                  // Trigger DOM refresh after a delay to ensure cart API is updated
                  setTimeout(() => {
                    if (cartDrawerItems.forceCartDrawerDOMRefresh) {
                      cartDrawerItems.forceCartDrawerDOMRefresh(cartDrawer);
                    } else {
                      // Fallback to standard update
                      cartDrawerItems.onCartUpdate();
                    }
                  }, 400); // Increased delay to ensure cart is updated
                } else {
                  // For non-empty cart, use single update call
                  // Open drawer first
                  setTimeout(() => {
                    cartDrawer.open();
                  }, 100);

                  // Then update cart content once
                  setTimeout(() => {
                    cartDrawerItems.onCartUpdate();
                  }, 250);
                }
              } else {
                // Fallback for when components aren't ready
                console.log('Cart components not ready, using fallback');
                if (this.cart && this.cart.renderContents) {
                  this.cart.renderContents(response);
                }

                // Always try to open cart drawer
                setTimeout(() => {
                  if (cartDrawer && cartDrawer.open) {
                    console.log('Opening cart drawer via fallback');
                    cartDrawer.open();
                  }
                }, 200);
              }
            }
          })
          .catch((e) => {
            console.error(e);
            // Dispatch cart updated event even on error
            document.dispatchEvent(
              new CustomEvent('cart:updated', {
                detail: { error: true, source: 'product-form' },
              })
            );
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');

            const isQuickAddButton = this.submitButton.classList.contains('quick-add__submit');

            if (!this.error) {
              this.submitButton.removeAttribute('aria-disabled');

              // Only show text feedback for non-quick-add buttons
              if (!isQuickAddButton && this.submitButtonText) {
                this.submitButtonText.textContent = 'Added!';
                setTimeout(() => {
                  this.submitButtonText.textContent = this.submitButton.dataset.originalText || 'Add to cart';
                }, 1500);
              }
            } else {
              if (!isQuickAddButton && this.submitButtonText) {
                this.submitButtonText.textContent = this.submitButton.dataset.originalText || 'Add to cart';
              }
            }

            const spinner = this.querySelector('.loading__spinner');
            if (spinner) {
              spinner.classList.add('hidden');
            }

            // Also remove loading state from sticky button and restore text
            const stickyButton = document.querySelector('.product-bottom-sticky__add-to-cart');
            if (stickyButton) {
              stickyButton.classList.remove('loading');
              const stickySpinner = stickyButton.querySelector('.loading__spinner');
              if (stickySpinner) {
                stickySpinner.classList.add('hidden');
              }

              // Restore sticky button text
              const stickyButtonText = stickyButton.querySelector('h5');
              if (stickyButtonText && !this.error) {
                stickyButtonText.textContent = 'Added!';
                setTimeout(() => {
                  stickyButtonText.textContent = stickyOriginalText || 'Add to cart';
                }, 1500);
              } else if (stickyButtonText && this.error) {
                stickyButtonText.textContent = stickyOriginalText || 'Add to cart';
              }
            }

            // Don't hide loading here - let cart update handle it
            // The cart drawer update will hide loading after content is ready
            console.log('Product form complete - cart update will handle loading state');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
